import $ from '../$';
import unique from '../functions/unique';
$.unique = unique;
